import * as Data$dEuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
const $Ratio = (_1, _2) => ({tag: "Ratio", _1, _2});
const Ratio = value0 => value1 => $Ratio(value0, value1);
const showRatio = dictShow => ({show: v => dictShow.show(v._1) + " % " + dictShow.show(v._2)});
const reduce = dictOrd => dictEuclideanRing => n => d => {
  const $0 = dictOrd.Eq0();
  const g = $0.eq(d)(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().zero) ? n : Data$dEuclideanRing.gcd($0)(dictEuclideanRing)(d)(dictEuclideanRing.mod(n)(d));
  const d$p = dictEuclideanRing.div(d)(g);
  return $Ratio(
    dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().mul(dictEuclideanRing.div(n)(g))((() => {
      const $1 = dictEuclideanRing.CommutativeRing0().Ring0();
      if (dictOrd.compare(d$p)($1.Semiring0().zero).tag === "LT") { return $1.sub($1.Semiring0().zero)($1.Semiring0().one); }
      if (dictOrd.compare(d$p)($1.Semiring0().zero).tag === "GT") { return $1.Semiring0().one; }
      return d$p;
    })()),
    (() => {
      const $1 = dictEuclideanRing.CommutativeRing0().Ring0();
      if (!(dictOrd.compare(d$p)($1.Semiring0().zero).tag === "LT")) { return d$p; }
      return $1.sub($1.Semiring0().zero)(d$p);
    })()
  );
};
const semiringRatio = dictOrd => dictEuclideanRing => (
  {
    one: $Ratio(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().one, dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().one),
    mul: v => v1 => reduce(dictOrd)(dictEuclideanRing)(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().mul(v._1)(v1._1))(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().mul(v._2)(v1._2)),
    zero: $Ratio(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().zero, dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().one),
    add: v => v1 => reduce(dictOrd)(dictEuclideanRing)(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().add(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().mul(v._1)(v1._2))(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().mul(v._2)(v1._1)))(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().mul(v._2)(v1._2))
  }
);
const ringRatio = dictOrd => dictEuclideanRing => (
  {
    sub: v => v1 => reduce(dictOrd)(dictEuclideanRing)(dictEuclideanRing.CommutativeRing0().Ring0().sub(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().mul(v._1)(v1._2))(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().mul(v._2)(v1._1)))(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().mul(v._2)(v1._2)),
    Semiring0: () => semiringRatio(dictOrd)(dictEuclideanRing)
  }
);
const numerator = v => v._1;
const eqRatio = dictEq => ({eq: v => v1 => dictEq.eq(v._1)(v1._1) && dictEq.eq(v._2)(v1._2)});
const ordRatio = dictOrd => dictEuclideanRing => (
  {
    compare: x => y => {
      const v = ringRatio(dictOrd)(dictEuclideanRing).sub(x)(y);
      if (dictOrd.Eq0().eq(v._1)(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().zero)) { return Data$dOrdering.EQ; }
      const v1 = dictOrd.compare(v._2)(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().zero).tag === "GT";
      const v2 = dictOrd.compare(v._1)(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().zero).tag === "GT";
      if (v2) {
        if (v1) { return Data$dOrdering.GT; }
        return Data$dOrdering.LT;
      }
      if (!v2) {
        if (!v1) { return Data$dOrdering.GT; }
        return Data$dOrdering.LT;
      }
      return Data$dOrdering.LT;
    },
    Eq0: () => {
      const $0 = dictOrd.Eq0();
      return {eq: v => v1 => $0.eq(v._1)(v1._1) && $0.eq(v._2)(v1._2)};
    }
  }
);
const divisionRingRatio = dictOrd => dictEuclideanRing => ({recip: v => $Ratio(v._2, v._1), Ring0: () => ringRatio(dictOrd)(dictEuclideanRing)});
const denominator = v => v._2;
const commutativeRingRatio = dictOrd => dictEuclideanRing => ({Ring0: () => ringRatio(dictOrd)(dictEuclideanRing)});
const euclideanRingRatio = dictOrd => dictEuclideanRing => (
  {
    degree: v => 1,
    div: v => v1 => reduce(dictOrd)(dictEuclideanRing)(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().mul(v._1)(v1._2))(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0().mul(v._2)(v1._1)),
    mod: v => v1 => semiringRatio(dictOrd)(dictEuclideanRing).zero,
    CommutativeRing0: () => ({Ring0: () => ringRatio(dictOrd)(dictEuclideanRing)})
  }
);
export {$Ratio, Ratio, commutativeRingRatio, denominator, divisionRingRatio, eqRatio, euclideanRingRatio, numerator, ordRatio, reduce, ringRatio, semiringRatio, showRatio};
